import useFetch from 'hooks/useFetch';
import { useMemo } from 'react';
import { listarPresentesPublicos, obterListaPublica } from 'services/listas';
import { ListaPublicaResponseDTO, PresentesPublicosResponseDTO } from './ListaPage.types';

export const useListaPageRules = (slugLista?: string, refreshKey: number = 0) => {
  const slug = slugLista ?? '';
  const fetchArgs = useMemo(() => (slug ? ([slug] as [string]) : undefined), [slug]);

  const {
    data: listaData,
    status: statusLista,
    error: erroLista,
  } = useFetch<[string], ListaPublicaResponseDTO>(obterListaPublica, {
    immediate: slug.length > 0,
    immediateArgs: fetchArgs,
    deps: [slug, refreshKey],
    timeoutMs: 12000,
  });

  const {
    data: presentesData,
    status: statusPresentes,
    error: erroPresentes,
  } = useFetch<[string], PresentesPublicosResponseDTO>(listarPresentesPublicos, {
    immediate: slug.length > 0,
    immediateArgs: fetchArgs,
    deps: [slug, refreshKey],
    timeoutMs: 12000,
  });

  const lista = listaData?.lista ?? null;
  const presentes = useMemo(() => presentesData?.presentes ?? [], [presentesData]);

  const presentesDisponiveis = useMemo(() => presentes.filter((p) => !p.presenteado), [presentes]);

  const presentesPresenteados = useMemo(() => presentes.filter((p) => p.presenteado), [presentes]);

  const formatarValor = (valor: number) =>
    valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  const carregando =
    slug.length > 0 &&
    (statusLista === 'idle' || statusLista === 'loading' || statusPresentes === 'loading');
  const erro = erroLista || erroPresentes || slug.length === 0;

  return {
    lista,
    presentes,
    presentesDisponiveis,
    presentesPresenteados,
    carregando,
    erro,
    formatarValor,
    slug,
    statusLista,
  };
};

export type UseListaPageRulesReturn = ReturnType<typeof useListaPageRules>;
